export default {
  updateAll(state, value) {
    state.all = value
  },
  updateSingle(state, value) {
    state.single = value
  },
  updateCreateFormData(state, params) {
    let obj = {}
    obj[params.namespace] = params.value
    state.createFormData = Object.assign({}, state.tabData, obj)
  },
  updateInlineEditingData(state, params) {
    let obj = {}
    obj[params.namespace] = params.value
    state.inlineEditingData = Object.assign({}, state.inlineEditingData, obj)
  }
}
